module.exports = __webpack_public_path__ + "static/img/1810_1.d32a556.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/pages/home/img/1810_1.jpg
// module id = LKwC
// module chunks = 1